// @flow
import * as React from 'react'

import Button from './atoms/Button.jsx'
import ErrorLabel from './atoms/ErrorLabel.jsx'
import Flex from './atoms/Flex'
import ModalDialog from './ModalDialog.jsx'
import PdfViewer from './molecules/PdfViewer.jsx'
import { QuestionTitle } from './Text'

type Props = {
  label?: string,
  isOfficeUse?: boolean,
  isRequired?: boolean,
  helpText?: ?string,
  hasError?: boolean,
  errorMessage?: string,
  isReadOnly?: boolean,
  file: string | null,
  onViewed?: () => void,
  onDownloaded?: () => void,
}

function HandoutQuestionRenderer({
  label,
  isOfficeUse,
  isRequired,
  helpText,
  hasError,
  errorMessage,
  file,
  isReadOnly,
  onDownloaded,
  onViewed,
}: Props): React.Node {
  const [showHandout, setShowHandout] = React.useState(false)
  const [isLoading, setIsLoading] = React.useState(true)
  const [isDownloading, setIsDownloading] = React.useState(false)

  const downloadPdf = async () => {
    if (file) {
      if (file.startsWith('http://') || file.startsWith('https://')) {
        const response = await fetch(file)
        const blob = await response.blob()
        const url = window.URL.createObjectURL(blob)
        const a = document.createElement('a')
        a.href = url
        a.download = `${label || 'downloaded'}.pdf` // specify the filename
        document.body?.appendChild(a)
        a.click()
        document.body?.removeChild(a)
        window.URL.revokeObjectURL(url)
      } else if (file.startsWith('data:application/pdf;base64,')) {
        const a = document.createElement('a')
        a.href = file
        a.download = `${label || 'downloaded'}.pdf` // specify the filename
        document.body?.appendChild(a)
        a.click()
        document.body?.removeChild(a)
      }
    }
  }

  return (
    <>
      <div>
        {label && (
          <QuestionTitle
            isOfficeUse={isOfficeUse}
            isRequired={isRequired || isReadOnly}
          >
            {label}
          </QuestionTitle>
        )}
        <Button
          $block
          $primary
          onClick={() => {
            file && setShowHandout(true)
          }}
        >
          {helpText || 'View'}
        </Button>
        {hasError && (
          <div>
            <ErrorLabel>{errorMessage}</ErrorLabel>
          </div>
        )}
      </div>
      {showHandout && (
        <ModalDialog
          hideCloseButton
          opened
          header={
            <Flex align="center" className="my-2.5 w-full pr-10" justify="end">
              <Button
                $primary
                disabled={isDownloading || isLoading}
                loading={isDownloading}
                onClick={async () => {
                  setIsDownloading(true)
                  try {
                    await downloadPdf()
                    onDownloaded && onDownloaded()
                  } finally {
                    setIsDownloading(false)
                  }
                }}
              >
                Download
              </Button>
            </Flex>
          }
          onClose={() => {
            setShowHandout(false)
          }}
          width="70vw"
        >
          <PdfViewer
            file={file}
            onLoad={() => {
              setIsLoading(false)
              onViewed && onViewed()
            }}
          />
        </ModalDialog>
      )}
    </>
  )
}

export default HandoutQuestionRenderer
